import { render, staticRenderFns } from "./MasterMaterial.vue?vue&type=template&id=31b84d0d&scoped=true&"
import script from "./MasterMaterial.vue?vue&type=script&lang=js&"
export * from "./MasterMaterial.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=31b84d0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b84d0d",
  null
  
)

export default component.exports